/**
 * InstitutionAllocation component module.
 * @module shared/components/InstitutionAllocation
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import Pie, {colorRender} from '../../../../shared/components/graphs/Pie';
import {_openModal} from '../../../../shared/reducers/modals';
import {connect} from 'react-redux';
import {getColorListPrimary, getColor} from '../../../../shared/utils/colors';
import useQueryObject from '../../../../shared/utils/useQueryObject';
import history from '../../../../history';
import {getInstitutions} from '../../../../shared/utils/containerUtils';
import {LoadingSpinner} from '../../../../shared';
import Row from '../../../../shared/components/Row';
import {buildQueryContext} from '../../../../shared/utils/utils';

const InstitutionGraph = ({containerID, openModal}) => {
  const colorList = [...getColorListPrimary()];
  const [context] = useQueryObject('context');

  const {data} = getInstitutions({
    con: {id: containerID},
    options: {onError: err => openModal({type: 'Error', title: 'Institution Allocation', err})},
  });

  const formattedData = React.useMemo(() => data
    && (data.length
      ? data.map(d => ({
        id: d.id,
        name: d.name || '',
        color: getColor(colorList),
        accounts: d.accountCounts && d.accountCounts.total || 0,
        balance: d.balance,
        y: Math.round(d.balancePercent * 1e4) / 1e2,
      }))
      : [{name: 'No Institution', color: '#797B83', y: 1}]), [data]);

  if (!formattedData) {
    return <LoadingSpinner/>;
  }
  return <Row height={'100px'}
              alignSubRow={'stretch'}
              alignItems={'stretch'}
              layout={{grow: 1}}>
    <Pie data={formattedData}
         table={{
           defaultSort: {column: 'balance', desc: true},
           columns: [
             {
               title: 'Institution',
               dataPoint: 'name',
               type: 'text',
               render: colorRender,
               minWidth: 100,
               isSortable: true,
               verticalAlign: true,
             },
             {
               title: 'Accounts',
               dataPoint: 'accounts',
               type: 'number',
               minWidth: 100,
               isSortable: true,
             },
             {
               title: 'Total Assets',
               dataPoint: 'balance',
               type: 'currency',
               minWidth: 100,
               isSortable: true,
             },
             {
               title: 'Percentage',
               dataPoint: 'y',
               type: 'percent',
               minWidth: 100,
               isSortable: true,
             },
           ],
         }}
         sliceAction={slice => history.push(`/analyze/containers/${containerID}/accounts?${buildQueryContext(
           context,
           {institutionName: slice.name}
         )}`)}
         centerAction={() => history.push(`/analyze/containers/${containerID}/institutions?${buildQueryContext(
           context,
           {dataSet: formattedData}
         )}`)}
    />
  </Row>;
};

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default connect(null, mapDispatchToProps)(InstitutionGraph);

InstitutionGraph.propTypes = {
  openModal: PropTypes.func,
  containerID: PropTypes.number.isRequired,
};
